import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  className?: string;
  bgColor?: string;
};

const CreateButton: React.FC<Props> = ({
  onClick,
  disabled,
  label = 'CREATE',
  className,
  bgColor = 'bg-customOrange',
}) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-[132px] h-[40px] ${bgColor} text-white rounded-lg text-sm ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
    >
      {t("createbutton.label")}
    </button>
  );
};

export default CreateButton;
